export enum TagType {
  Alerts = 'Alerts',
  Acl = 'Acl',
  AccessControl = 'AccessControl',
  AlgorithmMetrics = 'algorithmMetrics',
  ApiKey = 'ApiKey',
  Automation = 'Automation',
  ClauseLibrary = 'ClauseLibrary',
  Clients = 'Clients',
  CodeCash = 'CodeCash',
  ConversationalAi = 'ConversationalAi',
  CrmConnections = 'CrmConnections',
  DataFields = 'DataFields',
  DdeTables = 'DdeTables',
  DashboardV2 = 'DashboardV2',
  Department = 'Department',
  Document = 'Document',
  DocumentRestore = 'DocumentRestore',
  EsignatureActivities = 'EsignatureActivities',
  EsignatureEnvelope = 'EsignatureEnvelope',
  Fields = 'Fields',
  Folder = 'Folder',
  Groups = 'Groups',
  Highlight = 'Highlight',
  LibraryModel = 'LibraryModel',
  LibraryModels = 'LibraryModels',
  Parties = 'Parties',
  PromptModel = 'PromptModel',
  PromptModelProgress = 'PromptModelProgress',
  PromptModelResult = 'PromptModelResult',
  PromptModelSummary = 'PromptModelSummary',
  Clauses = 'Clauses',
  Roles = 'Roles',
  SaveSearch = 'SaveSearch',
  SearchV3 = 'SearchV3',
  SharepointConfiguration = 'SharepointConfiguration',
  SharepointOpenDocument = 'SharepointOpenDocument',
  SmartClause = 'SmartClause',
  Sylvanus = 'Sylvanus',
  TableViews = 'TableViews',
  Ticket = 'Ticket',
  TicketRecipients = 'TicketRecipients',
  TurnTracking = 'TurnTracking',
  UploadFiles = 'UploadFiles',
  UserPreferences = 'UserPreferences',
  Users = 'Users',
  Webhooks = 'Webhooks',
  Workflows = 'Workflows',
  Routings = 'Routings',
  TicketK2 = 'TicketK2',
  TaskK2 = 'TaskK2',
  TasksK2 = 'TasksK2',
  CommentsK2 = 'CommentsK2',
  CLMeFields = 'CLMeFields',
  CLMeClauses = 'CLMeClauses',
  SigningConfigurationK2 = 'SigningConfigurationK2',
  UnifiedField = 'UnifiedField',
}
